import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const EgresosReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    // ===================== INGRESOS =====================
    .addCase(Types.CONSULTAR_INGRESOS_PSS_LOADING, (state) => {
      state.consultarIngresosPssLoading = true;
      state.consultarIngresosPssError = null;
    })
    .addCase(Types.CONSULTAR_INGRESOS_PSS_SUCCESS, (state, action) => {
      const { consultarIngresosPssData } = action;
      state.consultarIngresosPssData = consultarIngresosPssData;
      state.consultarIngresosPssLoading = false;
      state.consultarIngresosPssError = null;
    })
    .addCase(Types.CONSULTAR_INGRESOS_PSS_FAILURE, (state, action) => {
      const { consultarIngresosPssError } = action;
      state.consultarIngresosPssData = INITIAL_STATE.consultarIngresosPssData;
      state.consultarIngresosPssLoading = false;
      state.consultarIngresosPssError = consultarIngresosPssError;
    })
    
    .addCase(Types.LIMPIAR_INGRESOS_PSS, (state) => {
      state.consultarIngresosPssData = INITIAL_STATE.consultarIngresosPssData;
      state.consultarIngresosPssLoading = false;
      state.consultarIngresosPssError = null;
    })

    .addCase(Types.ELIMINAR_COBERTURA_LOADING, (state) => {
      state.eliminarCoberturaLoading = true;
      state.eliminarCoberturaError = null;
    })
    .addCase(Types.ELIMINAR_COBERTURA_SUCCESS, (state, action) => {
      const { eliminarCoberturaData } = action;
      state.eliminarCoberturaData = eliminarCoberturaData;
      state.eliminarCoberturaLoading = false;
      state.eliminarCoberturaError = null;
    })
    .addCase(Types.ELIMINAR_COBERTURA_FAILURE, (state, action) => {
      const { eliminarCoberturaError } = action;
      state.eliminarCoberturaData = INITIAL_STATE.eliminarCoberturaData;
      state.eliminarCoberturaLoading = false;
      state.eliminarCoberturaError = eliminarCoberturaError;
    })
    .addCase(Types.ELIMINAR_COBERTURA_DE_INGRESO_DETALLE, (state, action) => {
      const { codigoCobertura } = action;
      if (state.consultarIngresosPssData?.ingresoDetalle) {
        state.consultarIngresosPssData.ingresoDetalle = 
          state.consultarIngresosPssData.ingresoDetalle.filter(
            (detalle) => String(detalle.cobertura) !== String(codigoCobertura)
          );
      }
    })
    .addCase(Types.LIMPIAR_ELIMINAR_COBERTURA, (state) => {
      state.eliminarCoberturaData = INITIAL_STATE.eliminarCoberturaData;
      state.eliminarCoberturaLoading = false;
      state.eliminarCoberturaError = null;
    })

    .addCase(Types.LIMPIAR_COBERTURAS_CIERRE_CUENTA, (state) => {
      state.consultarCoberturasCierreCuentaData =
        INITIAL_STATE.consultarCoberturasCierreCuentaData;
      state.consultarCoberturasCierreCuentaLoading = false;
      state.consultarCoberturasCierreCuentaError = null;
    })

    .addCase(Types.CONSULTAR_COBERTURAS_CIERRE_CUENTA_LOADING, (state) => {
      state.consultarCoberturasCierreCuentaLoading = true;
      state.consultarCoberturasCierreCuentaError = null;
    })
    .addCase(
      Types.CONSULTAR_COBERTURAS_CIERRE_CUENTA_SUCCESS,
      (state, action) => {
        const { consultarCoberturasCierreCuentaData } = action;
        state.consultarCoberturasCierreCuentaData =
          consultarCoberturasCierreCuentaData;
        state.consultarCoberturasCierreCuentaLoading = false;
        state.consultarCoberturasCierreCuentaError = null;
      }
    )
    .addCase(
      Types.CONSULTAR_COBERTURAS_CIERRE_CUENTA_FAILURE,
      (state, action) => {
        const { consultarCoberturasCierreCuentaError } = action;
        state.consultarCoberturasCierreCuentaData =
          INITIAL_STATE.consultarCoberturasCierreCuentaData;
        state.consultarCoberturasCierreCuentaLoading = false;
        state.consultarCoberturasCierreCuentaError =
          consultarCoberturasCierreCuentaError;
      }
    )

    // ===================== BUSCAR CUENTAS CERRADAS =====================
    .addCase(Types.BUSCAR_CUENTAS_CERRADAS_LOADING, (state) => {
      state.buscarCuentasCerradasLoading = true;
      state.buscarCuentasCerradasError = null;
    })
    .addCase(Types.BUSCAR_CUENTAS_CERRADAS_SUCCESS, (state, action) => {
      const { buscarCuentasCerradasData } = action;
      state.buscarCuentasCerradasData = buscarCuentasCerradasData;
      state.buscarCuentasCerradasLoading = false;
      state.buscarCuentasCerradasError = null;
    })
    .addCase(Types.BUSCAR_CUENTAS_CERRADAS_FAILURE, (state, action) => {
      const { buscarCuentasCerradasError } = action;
      state.buscarCuentasCerradasData = INITIAL_STATE.buscarCuentasCerradasData;
      state.buscarCuentasCerradasLoading = false;
      state.buscarCuentasCerradasError = buscarCuentasCerradasError;
    })
    .addCase(Types.LIMPIAR_BUSCAR_CUENTAS_CERRADAS, (state) => {
      state.buscarCuentasCerradasData = INITIAL_STATE.buscarCuentasCerradasData;
      state.buscarCuentasCerradasLoading = false;
      state.buscarCuentasCerradasError = null;
    })

    // ===================== VALIDAR COBERTURA =====================
    .addCase(Types.VALIDAR_COBERTURA_LOADING, (state) => {
      state.validarCoberturaLoading = true;
      state.validarCoberturaError = null;
    })
    .addCase(Types.VALIDAR_COBERTURA_SUCCESS, (state, action) => {
      const { validarCoberturaData } = action;
      state.validarCoberturaData = validarCoberturaData;
      state.validarCoberturaLoading = false;
      state.validarCoberturaError = null;
    })
    .addCase(Types.VALIDAR_COBERTURA_FAILURE, (state, action) => {
      const { validarCoberturaError } = action;
      state.validarCoberturaData = INITIAL_STATE.validarCoberturaData;
      state.validarCoberturaLoading = false;
      state.validarCoberturaError = validarCoberturaError;
    })
    .addCase(Types.LIMPIAR_VALIDAR_COBERTURA, (state) => {
      state.validarCoberturaData = INITIAL_STATE.validarCoberturaData;
      state.validarCoberturaLoading = false;
      state.validarCoberturaError = null;
    })

    // ===================== VALIDAR SERVICIO AMBULATORIO =====================
    .addCase(Types.VALIDAR_SERVICIO_AMBULATORIO_LOADING, (state) => {
      state.validarServicioAmbulatorioLoading = true;
      state.validarServicioAmbulatorioError = null;
    })
    .addCase(Types.VALIDAR_SERVICIO_AMBULATORIO_SUCCESS, (state, action) => {
      const { validarServicioAmbulatorioData } = action;
      state.validarServicioAmbulatorioData = validarServicioAmbulatorioData;
      state.validarServicioAmbulatorioLoading = false;
      state.validarServicioAmbulatorioError = null;
    })
    .addCase(Types.VALIDAR_SERVICIO_AMBULATORIO_FAILURE, (state, action) => {
      const { validarServicioAmbulatorioError } = action;
      state.validarServicioAmbulatorioData = INITIAL_STATE.validarServicioAmbulatorioData;
      state.validarServicioAmbulatorioLoading = false;
      state.validarServicioAmbulatorioError = validarServicioAmbulatorioError;
    })
    .addCase(Types.LIMPIAR_VALIDAR_SERVICIO_AMBULATORIO, (state) => {
      state.validarServicioAmbulatorioData = INITIAL_STATE.validarServicioAmbulatorioData;
      state.validarServicioAmbulatorioLoading = false;
      state.validarServicioAmbulatorioError = null;
    })

    // ===================== CONSULTAR TIPO PSS NO MEDICO =====================
    .addCase(Types.CONSULTAR_TIPO_PSS_NO_MEDICO_EGRESO_LOADING, (state) => {
      state.consultarTipoPssNoMedicoLoading = true;
      state.consultarTipoPssNoMedicoError = null;
    })
    .addCase(Types.CONSULTAR_TIPO_PSS_NO_MEDICO_EGRESO_SUCCESS, (state, action) => {
      const { consultarTipoPssNoMedicoData } = action;
      state.consultarTipoPssNoMedicoData = consultarTipoPssNoMedicoData;
      state.consultarTipoPssNoMedicoLoading = false;
      state.consultarTipoPssNoMedicoError = null;
    })
    .addCase(Types.CONSULTAR_TIPO_PSS_NO_MEDICO_EGRESO_FAILURE, (state, action) => {
      const { consultarTipoPssNoMedicoError } = action;
      state.consultarTipoPssNoMedicoData = INITIAL_STATE.consultarTipoPssNoMedicoData;
      state.consultarTipoPssNoMedicoLoading = false;
      state.consultarTipoPssNoMedicoError = consultarTipoPssNoMedicoError;
    })
    .addCase(Types.LIMPIAR_CONSULTAR_TIPO_PSS_NO_MEDICO, (state) => {
      state.consultarTipoPssNoMedicoData = INITIAL_STATE.consultarTipoPssNoMedicoData;
      state.consultarTipoPssNoMedicoLoading = false;
      state.consultarTipoPssNoMedicoError = null;
    })

    // ===================== VALIDAR AFILIADO VIGENTE =====================
    .addCase(Types.VALIDAR_AFILIADO_VIGENTE_LOADING, (state) => {
      state.validarAfiliadoVigenteLoading = true;
      state.validarAfiliadoVigenteError = null;
    })
    .addCase(Types.VALIDAR_AFILIADO_VIGENTE_SUCCESS, (state, action) => {
      const { validarAfiliadoVigenteData } = action;
      state.validarAfiliadoVigenteData = validarAfiliadoVigenteData;
      state.validarAfiliadoVigenteLoading = false;
      state.validarAfiliadoVigenteError = null;
    })
    .addCase(Types.VALIDAR_AFILIADO_VIGENTE_FAILURE, (state, action) => {
      const { validarAfiliadoVigenteError } = action;
      state.validarAfiliadoVigenteData = INITIAL_STATE.validarAfiliadoVigenteData;
      state.validarAfiliadoVigenteLoading = false;
      state.validarAfiliadoVigenteError = validarAfiliadoVigenteError;
    })
    .addCase(Types.LIMPIAR_VALIDAR_AFILIADO_VIGENTE, (state) => {
      state.validarAfiliadoVigenteData = INITIAL_STATE.validarAfiliadoVigenteData;
      state.validarAfiliadoVigenteLoading = false;
      state.validarAfiliadoVigenteError = null;
    })

    // ===================== GUARDAR EGRESO =====================
    .addCase(Types.GUARDAR_EGRESO_LOADING, (state) => {
      state.guardarEgresoLoading = true;
      state.guardarEgresoError = null;
    })
    .addCase(Types.GUARDAR_EGRESO_SUCCESS, (state, action) => {
      const { guardarEgresoData } = action;
      state.guardarEgresoData = guardarEgresoData;
      state.guardarEgresoLoading = false;
      state.guardarEgresoError = null;
    })
    .addCase(Types.GUARDAR_EGRESO_FAILURE, (state, action) => {
      const { guardarEgresoError } = action;
      state.guardarEgresoData = INITIAL_STATE.guardarEgresoData;
      state.guardarEgresoLoading = false;
      state.guardarEgresoError = guardarEgresoError;
    })
    .addCase(Types.LIMPIAR_GUARDAR_EGRESO, (state) => {
      state.guardarEgresoData = INITIAL_STATE.guardarEgresoData;
      state.guardarEgresoLoading = false;
      state.guardarEgresoError = null;
    })

    // ===================== CONSULTAR RECLAMANTES =====================
    .addCase(Types.CONSULTAR_RECLAMANTES_LOADING, (state) => {
      state.consultarReclamantesLoading = true;
      state.consultarReclamantesError = null;
    })
    .addCase(Types.CONSULTAR_RECLAMANTES_SUCCESS, (state, action) => {
      const { consultarReclamantesData } = action;
      state.consultarReclamantesData = consultarReclamantesData;
      state.consultarReclamantesLoading = false;
      state.consultarReclamantesError = null;
    })
    .addCase(Types.CONSULTAR_RECLAMANTES_FAILURE, (state, action) => {
      const { consultarReclamantesError } = action;
      state.consultarReclamantesData = INITIAL_STATE.consultarReclamantesData;
      state.consultarReclamantesLoading = false;
      state.consultarReclamantesError = consultarReclamantesError;
    })
    .addCase(Types.LIMPIAR_CONSULTAR_RECLAMANTES, (state) => {
      state.consultarReclamantesData = INITIAL_STATE.consultarReclamantesData;
      state.consultarReclamantesLoading = false;
      state.consultarReclamantesError = null;
    })

    // ===================== CALCULAR OXIGENO =====================
    .addCase(Types.CALCULAR_OXIGENO_LOADING, (state) => {
      state.calcularOxigenoLoading = true;
      state.calcularOxigenoError = null;
    })
    .addCase(Types.CALCULAR_OXIGENO_SUCCESS, (state, action) => {
      const { calcularOxigenoData } = action;
      state.calcularOxigenoData = calcularOxigenoData;
      state.calcularOxigenoLoading = false;
      state.calcularOxigenoError = null;
    })
    .addCase(Types.CALCULAR_OXIGENO_FAILURE, (state, action) => {
      const { calcularOxigenoError } = action;
      state.calcularOxigenoData = INITIAL_STATE.calcularOxigenoData;
      state.calcularOxigenoLoading = false;
      state.calcularOxigenoError = calcularOxigenoError;
    })
    .addCase(Types.LIMPIAR_CALCULAR_OXIGENO, (state) => {
      state.calcularOxigenoData = INITIAL_STATE.calcularOxigenoData;
      state.calcularOxigenoLoading = false;
      state.calcularOxigenoError = null;
    })
    // ===================== INSERTAR COBERTURA =====================
    .addCase(Types.INSERTAR_COBERTURA_LOADING, (state) => {
      state.insertarCoberturaLoading = true;
      state.insertarCoberturaError = null;
    })
    .addCase(Types.INSERTAR_COBERTURA_SUCCESS, (state, action) => {
      const { insertarCoberturaData } = action;
      state.insertarCoberturaData = insertarCoberturaData;
      state.insertarCoberturaLoading = false;
      state.insertarCoberturaError = null;
    })
    .addCase(Types.INSERTAR_COBERTURA_FAILURE, (state, action) => {
      const { insertarCoberturaError } = action;
      state.insertarCoberturaData = INITIAL_STATE.insertarCoberturaData;
      state.insertarCoberturaLoading = false;
      state.insertarCoberturaError = insertarCoberturaError;
    })
    .addCase(Types.LIMPIAR_INSERTAR_COBERTURA, (state) => {
      state.insertarCoberturaData = INITIAL_STATE.insertarCoberturaData;
      state.insertarCoberturaLoading = false;
      state.insertarCoberturaError = null;
    })

    // ===================== CERRAR CUENTA CLINICA =====================
    .addCase(Types.CERRAR_CUENTA_CLINICA_LOADING, (state) => {
      state.cerrarCuentaClinicaLoading = true;
      state.cerrarCuentaClinicaError = null;
    })
    .addCase(Types.CERRAR_CUENTA_CLINICA_SUCCESS, (state, action) => {
      const { cerrarCuentaClinicaData } = action;
      state.cerrarCuentaClinicaData = cerrarCuentaClinicaData;
      state.cerrarCuentaClinicaLoading = false;
      state.cerrarCuentaClinicaError = null;
    })
    .addCase(Types.CERRAR_CUENTA_CLINICA_FAILURE, (state, action) => {
      const { cerrarCuentaClinicaError } = action;
      state.cerrarCuentaClinicaData = INITIAL_STATE.cerrarCuentaClinicaData;
      state.cerrarCuentaClinicaLoading = false;
      state.cerrarCuentaClinicaError = cerrarCuentaClinicaError;
    })
    .addCase(Types.LIMPIAR_CERRAR_CUENTA_CLINICA, (state) => {
      state.cerrarCuentaClinicaData = INITIAL_STATE.cerrarCuentaClinicaData;
      state.cerrarCuentaClinicaLoading = false;
      state.cerrarCuentaClinicaError = null;
    })

    // ===================== VALIDAR INGRESO EXISTENTE =====================
    .addCase(Types.VALIDAR_INGRESO_EXISTENTE_LOADING, (state) => {
      state.validarIngresoExistenteLoading = true;
      state.validarIngresoExistenteError = null;
    })
    .addCase(Types.VALIDAR_INGRESO_EXISTENTE_SUCCESS, (state, action) => {
      const { validarIngresoExistenteData } = action;
      state.validarIngresoExistenteData = validarIngresoExistenteData;
      state.validarIngresoExistenteLoading = false;
      state.validarIngresoExistenteError = null;
    })
    .addCase(Types.VALIDAR_INGRESO_EXISTENTE_FAILURE, (state, action) => {
      const { validarIngresoExistenteError } = action;
      state.validarIngresoExistenteData = INITIAL_STATE.validarIngresoExistenteData;
      state.validarIngresoExistenteLoading = false;
      state.validarIngresoExistenteError = validarIngresoExistenteError;
    })
    .addCase(Types.LIMPIAR_VALIDAR_INGRESO_EXISTENTE, (state) => {
      state.validarIngresoExistenteData = INITIAL_STATE.validarIngresoExistenteData;
      state.validarIngresoExistenteLoading = false;
      state.validarIngresoExistenteError = null;
    })

    // ===================== ENVIAR RECLAMACION =====================
    .addCase(Types.ENVIAR_RECLAMACION_LOADING, (state) => {
      state.enviarReclamacionLoading = true;
      state.enviarReclamacionError = null;
    })
    .addCase(Types.ENVIAR_RECLAMACION_SUCCESS, (state, action) => {
      const { enviarReclamacionData } = action;
      state.enviarReclamacionData = enviarReclamacionData;
      state.enviarReclamacionLoading = false;
      state.enviarReclamacionError = null;
    })
    .addCase(Types.ENVIAR_RECLAMACION_FAILURE, (state, action) => {
      const { enviarReclamacionError } = action;
      state.enviarReclamacionData = INITIAL_STATE.enviarReclamacionData;
      state.enviarReclamacionLoading = false;
      state.enviarReclamacionError = enviarReclamacionError;
    })
    .addCase(Types.LIMPIAR_ENVIAR_RECLAMACION, (state) => {
      state.enviarReclamacionData = INITIAL_STATE.enviarReclamacionData;
      state.enviarReclamacionLoading = false;
      state.enviarReclamacionError = null;
    })

    // ===================== CAMBIAR SERVICIO =====================
    .addCase(Types.CAMBIAR_SERVICIO_LOADING, (state) => {
      state.cambiarServicioLoading = true;
      state.cambiarServicioError = null;
    })
    .addCase(Types.CAMBIAR_SERVICIO_SUCCESS, (state, action) => {
      const { cambiarServicioData } = action;
      state.cambiarServicioData = cambiarServicioData;
      state.cambiarServicioLoading = false;
      state.cambiarServicioError = null;
    })
    .addCase(Types.CAMBIAR_SERVICIO_FAILURE, (state, action) => {
      const { cambiarServicioError } = action;
      state.cambiarServicioData = INITIAL_STATE.cambiarServicioData;
      state.cambiarServicioLoading = false;
      state.cambiarServicioError = cambiarServicioError;
    })
    .addCase(Types.LIMPIAR_CAMBIAR_SERVICIO, (state) => {
      state.cambiarServicioData = INITIAL_STATE.cambiarServicioData;
      state.cambiarServicioLoading = false;
      state.cambiarServicioError = null;
    })

    /**
   * Actualizar form de consulta de cierres de cuentas
   */
    .addCase(Types.FORM_CONSULTA_CIERRES_CUENTAS_LOADING, (state) => {
      state.formConsultaCierresCuentasLoading = true;
    })
    .addCase(Types.FORM_CONSULTA_CIERRES_CUENTAS_SUCCESS, (state, action) => {
      const { formConsultaCierresCuentasData } = action;
      state.formConsultaCierresCuentasData = formConsultaCierresCuentasData;
      state.formConsultaCierresCuentasLoading = false;
      state.consultarCierresCuentasLoading = false;
    }) 
    
    /**
     *  Consultar cierres cuentas
    */
    .addCase(Types.CONSULTAR_CIERRES_CUENTAS_LOADING, (state) => {
      state.consultarCierresCuentasLoading = true;
    })

    /**
     *  Consultar planes egreso (dropdown Plan de Salud)
     */
    .addCase(Types.CONSULTAR_PLANES_EGRESO_LOADING, (state) => {
      state.consultarPlanesEgresoLoading = true;
      state.consultarPlanesEgresoError = null;
    })
    .addCase(Types.CONSULTAR_PLANES_EGRESO_SUCCESS, (state, action) => {
      const { consultarPlanesEgresoData } = action;
      state.consultarPlanesEgresoData = consultarPlanesEgresoData;
      state.consultarPlanesEgresoLoading = false;
      state.consultarPlanesEgresoError = null;
    })
    .addCase(Types.CONSULTAR_PLANES_EGRESO_FAILURE, (state, action) => {
      const { consultarPlanesEgresoError } = action;
      state.consultarPlanesEgresoData = INITIAL_STATE.consultarPlanesEgresoData;
      state.consultarPlanesEgresoLoading = false;
      state.consultarPlanesEgresoError = consultarPlanesEgresoError;
    })

    /**
     *  Consultar estatus hoja quirúrgica
    */
    .addCase(Types.CONSULTAR_ESTATUS_HOJA_QUIRURGICA_LOADING, (state) => {
      state.consultarEstatusHojaQuirurgicaLoading = true;
      state.consultarEstatusHojaQuirurgicaError = null;
    })
    .addCase(Types.CONSULTAR_ESTATUS_HOJA_QUIRURGICA_SUCCESS, (state, action) => {
      const { consultarEstatusHojaQuirurgicaData } = action;
      state.consultarEstatusHojaQuirurgicaData = consultarEstatusHojaQuirurgicaData;
      state.consultarEstatusHojaQuirurgicaLoading = false;
      state.consultarEstatusHojaQuirurgicaError = null;
    })
    .addCase(Types.CONSULTAR_ESTATUS_HOJA_QUIRURGICA_FAILURE, (state, action) => {
      const { consultarEstatusHojaQuirurgicaError } = action;
      state.consultarEstatusHojaQuirurgicaData = INITIAL_STATE.consultarEstatusHojaQuirurgicaData;
      state.consultarEstatusHojaQuirurgicaLoading = false;
      state.consultarEstatusHojaQuirurgicaError = consultarEstatusHojaQuirurgicaError;
    })
    .addCase(Types.LIMPIAR_CONSULTAR_ESTATUS_HOJA_QUIRURGICA, (state) => {
      state.consultarEstatusHojaQuirurgicaData = INITIAL_STATE.consultarEstatusHojaQuirurgicaData;
      state.consultarEstatusHojaQuirurgicaLoading = false;
      state.consultarEstatusHojaQuirurgicaError = null;
    })

    /**
     * Consultar ingreso detalle cobertura hoja QX
     */
    .addCase(Types.CONSULTA_INGRESO_DETALLE_COBERTURA_HOJA_QX_LOADING, (state) => {
      state.consultaIngresoDetalleCoberturaHojaQxLoading = true;
      state.consultaIngresoDetalleCoberturaHojaQxError = null;
    })
    .addCase(Types.CONSULTA_INGRESO_DETALLE_COBERTURA_HOJA_QX_SUCCESS, (state, action) => {
      const { consultaIngresoDetalleCoberturaHojaQxData } = action;
      state.consultaIngresoDetalleCoberturaHojaQxData = consultaIngresoDetalleCoberturaHojaQxData;
      state.consultaIngresoDetalleCoberturaHojaQxLoading = false;
      state.consultaIngresoDetalleCoberturaHojaQxError = null;
    })
    .addCase(Types.CONSULTA_INGRESO_DETALLE_COBERTURA_HOJA_QX_FAILURE, (state, action) => {
      const { consultaIngresoDetalleCoberturaHojaQxError } = action;
      state.consultaIngresoDetalleCoberturaHojaQxData = INITIAL_STATE.consultaIngresoDetalleCoberturaHojaQxData;
      state.consultaIngresoDetalleCoberturaHojaQxLoading = false;
      state.consultaIngresoDetalleCoberturaHojaQxError = consultaIngresoDetalleCoberturaHojaQxError;
    })
    .addCase(Types.LIMPIAR_CONSULTA_INGRESO_DETALLE_COBERTURA_HOJA_QX, (state) => {
      state.consultaIngresoDetalleCoberturaHojaQxData = INITIAL_STATE.consultaIngresoDetalleCoberturaHojaQxData;
      state.consultaIngresoDetalleCoberturaHojaQxLoading = false;
      state.consultaIngresoDetalleCoberturaHojaQxError = null;
    })

    // ===================== CONSULTAR DÍAS HOSPITALARIOS =====================
    .addCase(Types.CONSULTAR_DIAS_HOSPITALARIOS_LOADING, (state) => {
      state.consultarDiasHospitalariosLoading = true;
      state.consultarDiasHospitalariosError = null;
    })
    .addCase(Types.CONSULTAR_DIAS_HOSPITALARIOS_SUCCESS, (state, action) => {
      const { consultarDiasHospitalariosData } = action;
      state.consultarDiasHospitalariosData = consultarDiasHospitalariosData;
      state.consultarDiasHospitalariosLoading = false;
      state.consultarDiasHospitalariosError = null;
    })
    .addCase(Types.CONSULTAR_DIAS_HOSPITALARIOS_FAILURE, (state, action) => {
      const { consultarDiasHospitalariosError } = action;
      state.consultarDiasHospitalariosData = INITIAL_STATE.consultarDiasHospitalariosData;
      state.consultarDiasHospitalariosLoading = false;
      state.consultarDiasHospitalariosError = consultarDiasHospitalariosError;
    })
    .addCase(Types.LIMPIAR_CONSULTAR_DIAS_HOSPITALARIOS, (state) => {
      state.consultarDiasHospitalariosData = INITIAL_STATE.consultarDiasHospitalariosData;
      state.consultarDiasHospitalariosLoading = false;
      state.consultarDiasHospitalariosError = null;
    });
});
